import React, { useState } from 'react';
import { TreeView } from '@mui/lab';
import { ExpandMore, ChevronRight } from '@mui/icons-material';
import muiStyles from './muiStyles';
import TreeNav from './TreeNav';

const RecursiveTreeView = ({ routers, pinned }) => {
    const [expandedGroups, setExpandedGroups] = useState([]); // Track expanded nodes
    // const [selectedNode, setSelectedNode] = useState(null); // Track selected node
    const classes = muiStyles();

    // Handle selection and expansion logic
    const handleSelect = (event, nodeId, parentPath) => {
        if (expandedGroups.includes(nodeId)) {
            //  setSelectedNode(null);
            setExpandedGroups([...parentPath]);

        } else {
            // setSelectedNode(nodeId); // Set the selected node

            // Get all parent paths to keep them expanded
            const newExpandedGroups = parentPath ? [...parentPath, nodeId] : [nodeId];

            setExpandedGroups(newExpandedGroups); // Update the expanded nodes to the selected path
        }

    };

    // Recursive function to render tree items
    const renderTreeItems = (items, level = 0, parentPath = []) => {
        return items.map((item) => {
            const isGroup = item.isGroup;
            const currentPath = [...parentPath, item.path || item.title]; // Build the current path
            const uniqueKey = crypto.randomUUID();

            // For group items (with sub-items)
            if (isGroup) {
                return (
                    <TreeNav
                        key={uniqueKey}
                        item={item}
                        parentPath={parentPath}
                        handleSelect={handleSelect}
                        exact={true}
                    >
                        {item.items && renderTreeItems(item.items, level + 1, currentPath)}
                    </TreeNav>


                );
            }

            // For non-group (child) items
            return (
                <TreeNav
                    key={item.id}
                    item={item}
                    parentPath={parentPath}
                    handleSelect={handleSelect}
                    exact={true}
                />
            );
        });
    };

    return (
        <TreeView
            key="menuNodeId"
            expanded={expandedGroups}
            defaultCollapseIcon={pinned ? <ExpandMore /> : <></>}
            defaultExpandIcon={pinned ? <ChevronRight /> : <></>}
            sx={{
                '& .MuiTreeItem-content': {
                    display: 'flex',
                    flexDirection: 'row-reverse', // move expand/collapse icon to the right
                    alignItems: 'baseline',
                    px: 1,
                },
                '& .MuiTreeItem-iconContainer': {
                    marginLeft: 'auto', // push expand icon to the far right
                    display: {
                        xs: 'none', // ⛔ Hide on mobile (xs < 600px)
                        sm: 'block', // ✅ Show on small screens and up
                    },
                },
                '& .MuiTreeItem-label': {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    width: '100%',
                },
            }}
        >
            {renderTreeItems(routers)}
        </TreeView>

    );
};

export default RecursiveTreeView;
